import { IonChip, IonLabel, IonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setFilterByDateModal } from "../../../store/documentList";
import { selectCreatedAtFilter } from "../../../store/documentList/selectors/selectCreatedAtFilter";
const dateFormat = new Intl.DateTimeFormat("es-MX");

export const FilterDateChip = () => {
  const dispatch = useDispatch();
  const createdAtFilter = useSelector(selectCreatedAtFilter);
  return (
    <IonChip
      onClick={() => dispatch(setFilterByDateModal(true))}
      outline
      color={createdAtFilter.from && createdAtFilter.to ? "primary" : "medium"}
    >
      <IonLabel class="ion-text-nowrap">
        {createdAtFilter.from && createdAtFilter.to ? (
          <IonText color="primary" style={{ fontWeight: 600 }}>
            <span>Fecha: </span>
            {dateFormat.format(new Date(createdAtFilter.from))} -{" "}
            {dateFormat.format(new Date(createdAtFilter.to))}
          </IonText>
        ) : (
          <span>Fecha: Cualquiera</span>
        )}
      </IonLabel>
    </IonChip>
  );
};
